/* Dependencies
 ---------------------------------------------------------- */
import { Application } from 'wrapper6'

/* Services
 ---------------------------------------------------------- */

/* Register services
 ---------------------------------------------------------- */

/* Modules
 ---------------------------------------------------------- */
import Navigation from 'modules/_navigation'
import ObjectFit from 'modules/_object-fit'
import Print from 'modules/_print'
import LazyLoad from './modules/_lazy-load'
import VideoModal from './modules/_video-modal'
import ProductTooltip from './modules/_product-tooltip'
import Accordion from './modules/woocommerce/_accordion'
import SelectVariations from './modules/woocommerce/_select-variations'
import PostsPager from './modules/woocommerce/_posts-pager'
import MiniCart from './modules/woocommerce/_mini_cart'
import ProductFilter from './modules/woocommerce/_product-filter'
import AddToCart from './modules/woocommerce/_add-to-cart'
import Sliders from './modules/_sliders'
import CasesFilter from './modules/_cases-filter'
import SmoothScroll from './modules/_smooth-scroll'
import ShippingDescription from './modules/woocommerce/_shipping-description'
import UserLogin from './modules/woocommerce/_user-login'
import FadeImages from './modules/_fade-images'
import CheckoutFragment from './modules/woocommerce/_checkout-fragment'
import CoverSlider from './modules/_cover-slider'
import Modal from "./modules/_modal";
import ProductModal from "./modules/_product-modal";
import ImageBankCoverSlider from "./modules/_image-bank-cover-slider";
import '@a11y/focus-trap'

/* Vendor
 ---------------------------------------------------------- */

/* Setup
 ---------------------------------------------------------- */
const app = window.app = new Application(window.options || {})

/* Register modules
 ---------------------------------------------------------- */
app.use(Navigation)
app.use(ObjectFit)
app.use(Print)
app.use(LazyLoad)
app.use(VideoModal)
app.use(ProductTooltip)
app.use(Accordion)
app.use(SelectVariations)
app.use(PostsPager)
app.use(MiniCart)
app.use(ProductFilter)
app.use(AddToCart)
app.use(Sliders)
app.use(CasesFilter)
app.use(ShippingDescription)
app.use(UserLogin)
app.use(SmoothScroll)
app.use(FadeImages)
app.use(CheckoutFragment)
CoverSlider()
app.use(Modal)
app.use(ProductModal)
ImageBankCoverSlider()

require('./app')
